import React from 'react'
import styled from 'styled-components'

import WinItBackgroundLogos from './WinItBackgroundLogos'

const PageContainer = styled.div`
  font-family: ${props => props.theme.fonts.avenirNextDemi};
  padding: 2rem;
  font-size: 2rem;
  display: flex;
  flex-direction: column;
  color: ${props => props.theme.colors.text.inputPlaceholder};
  h1 {
    font-family: ${props => props.theme.fonts.avenirNextHeavy};
    color: ${props => props.theme.colors.text.label};
  }
`

const ErrorPage = ({ children }) => {
  return (
    <WinItBackgroundLogos>
      <PageContainer>{children}</PageContainer>
    </WinItBackgroundLogos>
  )
}

export default ErrorPage
